export default __webpack_public_path__ + "static/media/twitter.04b8d2bc.svg";